// extracted by mini-css-extract-plugin
module.exports = {"stock_info":"stock_info-3FJgsdTk","price":"price-3pf-XK6d","red":"red-mUAGKDyu","green":"green-1_UxDuP7","black":"black-3orZ6Gij"};